export const TreeProp = Object.freeze({
    Elements: 'elements',
    ElementsAddressBook: 'elementsAddressBook',
    ExpandedElements: 'expandedElements',
    SidePaneWidget: 'sidePaneWidget',
    SelectedElementUniqueId: 'selectedElementUniqueId',
});